import React, { useState } from "react";
import { formatDate, milisecOf } from "../../../utils/Utils";
import { DealStatus } from "../../../Const";
import ConfirmationModal from "../../common/ConfirmationModal";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const BotDealTab = (props) => {
  const { deals,startItem,itemsPerPage,selectedExchangeId,pageNum,botId,deleteDeal,onDeleteSuccess} = props;
  const { t } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [dealToDelete, setDealToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  //const itemsPerPage = 10;
  //const [startItem, setStartItem] = useState(0);
  const handleDeleteClick = (dealId) => {
    setDealToDelete(dealId);
    setShowConfirmModal(true);
  };

  const handleDeleteConfirm = () => {
    if (!dealToDelete) {
      return;
    }
    setDeleting(true);
    deleteDeal(dealToDelete, selectedExchangeId, itemsPerPage, pageNum, "completed", botId)
      .then(() => {
        setDeleting(false);
        setShowConfirmModal(false);
        setDealToDelete(null);
        toast.info(t("deal-deleted"));
        if (onDeleteSuccess) {
          onDeleteSuccess();
        }
      })
      .catch((err) => {
        setDeleting(false);
        toast.error(err);
      });
  };

  const handleDeleteCancel = () => {
    if (deleting) {
      return;
    }
    setShowConfirmModal(false);
    setDealToDelete(null);
  };

  deals.forEach((item) => {
    item.closed_orders &&
      item.closed_orders.length &&
      item.closed_orders.sort((order1, order2) => {
        return milisecOf(order1.date) - milisecOf(order2.date);
      });
  });
  deals.sort((item1, item2) => {
    if (
      item1.closed_orders &&
      item1.closed_orders.length &&
      item2.closed_orders &&
      item2.closed_orders.length
    )
      return (
        milisecOf(item2.closed_orders[0].date) -
        milisecOf(item1.closed_orders[0].date)
      );
    return 0;
  });
  const dealItems = deals
    //.slice(startItem, startItem + itemsPerPage)
    .filter((item) => item.status == "completed")
    .map((item, index) => {
      const status = item.status_key.toLowerCase();
      const statusVariant = [
        //DealStatus.stopLoss,
        DealStatus.liquidating,
        DealStatus.liquidated,
        //DealStatus.stoppingLoss,
      ].includes(status)
        ? "danger"
        : [DealStatus.takeProfit, DealStatus.takingProfit].includes(status)
        ? "success"
        : status == DealStatus.waiting
        ? "secondary"
        : item.net_profit >= 0
        ? "success"
        : "info";
      const numberOrder = item.closed_orders.length;
      return (
        <tr key={item.id || index}>
          <td>{startItem + index }</td>
          <td>
            {item.executed_vol.toFixed(2)} {item.base_name}
          </td>
          <td className={item.profit_value>=0?"text-success":"text-danger"}>
            {item.net_profit.toFixed(2)} {item.base_name} (
            {item.profit_value.toFixed(2)}%)
          </td>
          <td>
            <span className="w-75" variant={statusVariant}>
              {item.status_name}
            </span>
          </td>
          <td>
            
            {item.closed_orders[numberOrder - 1] && formatDate(
              item.closed_orders[numberOrder - 1].date,
              "YYYY-MM-DD HH:mm:ss",
              "MMM DD, YYYY HH:mm"
            )}
          </td>
          <td>
            <button
              type="button"
              className="bdt-delete-btn"
              onClick={() => handleDeleteClick(item.id)}
              title={t("Delete")}
              aria-label={t("Delete")}
            >
              <i className="far fa-trash-alt"></i>
            </button>
          </td>
        </tr>
      );
    });
  return (
    <div className="bdt-content">
    <div className="bdt-table-responsive">
      <table className="table">
                  <tbody>
                      <tr valign="top">
                      <td>#</td>
                      <td>Capital</td>
                      <td>Return</td>
                      <td>Exit Condition</td>
                      <td>Completed</td>
                      <td></td>
                      </tr>
                      {dealItems}
                  </tbody>
              </table>
          </div>
          <ConfirmationModal
            show={showConfirmModal}
            title={t("Confirm Delete")}
            body={t("Are you sure you want to delete this completed deal?")}
            onCancel={handleDeleteCancel}
            onConfirm={handleDeleteConfirm}
            confirmText={deleting ? t("Deleting...") : t("Confirm")}
            cancelText={t("Cancel")}
          />
    </div>
  );
};

export default BotDealTab;
